import clsx from 'clsx';
import React from 'react';
import Slider, { ResponsiveObject } from 'react-slick';
import styles from './style.module.scss';

type AppCarouselProps = {
  items: any[];
  title?: string;
  dots?: boolean;
  infinite?: boolean;
  speed?: number;
  slidesToShow: number;
  slidesToScroll: number;
  centerMode?: boolean;
  aditionalClass?: string;
  autoplay?: boolean;
  autoplaySpeed?: number;
  responsive?: ResponsiveObject[];
  dotsClass?: string;
};

const appCarouselResponsive: ResponsiveObject[] = [
  {
    breakpoint: 1025,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 2,
    },
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];

const AppCarousel: React.FC<AppCarouselProps> = ({
  title = '',
  dots = false,
  infinite = false,
  speed = 500,
  slidesToShow = 7,
  slidesToScroll = 1,
  aditionalClass = '',
  centerMode = false,
  items = [],
  autoplay = false,
  responsive = appCarouselResponsive,
  dotsClass = '',
}) => {
  const sliderRef = React.useRef<Slider>(null);

  return (
    <div className={styles['app-carousel-container']}>
      {title && title.length > 0 && <h1>{title}</h1>}
      <Slider
        dots={dots}
        infinite={infinite}
        speed={speed}
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToScroll}
        ref={sliderRef}
        className={clsx(aditionalClass && styles[aditionalClass])}
        centerMode={centerMode}
        responsive={responsive}
        autoplay={autoplay}
        dotsClass={dotsClass}
        accessibility={true}
        focusOnSelect={false}
      >
        {items.map((item, index) => (
          <div key={index} style={{ height: '100%' }}>
            {item}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default AppCarousel;
